import { useState } from 'react';

import { useTimeoutCallback } from '@sorare/core/src/hooks/animations/useTimeoutCallback';
import { useTimeoutFn } from '@sorare/core/src/hooks/animations/useTimeoutFn';

import { collectionAnimationConfig } from '#src/components/commonCard/RevealPackCardsDialog/CollectionAnimation/animationConfig.ts';

export const useAnimatingCardIndex = ({
  shouldAnimate,
}: {
  shouldAnimate: boolean;
}) => {
  const [animatingCardIndex, setAnimatingCardIndex] = useState<number>();

  useTimeoutFn(
    () => {
      setAnimatingCardIndex(0);
    },
    shouldAnimate && animatingCardIndex === undefined
      ? collectionAnimationConfig.cardEnterDelayMs
      : null
  );

  const setAnimatingCardIndexAfterScroll = useTimeoutCallback(
    (value: number) => {
      setAnimatingCardIndex(value);
    },
    collectionAnimationConfig.scrollDurationMs
  );
  return {
    animatingCardIndex,
    setAnimatingCardIndex,
    setAnimatingCardIndexAfterScroll,
  };
};
